import { render, staticRenderFns } from "./OldShop.vue?vue&type=template&id=0437329c&scoped=true&"
import script from "./OldShop.vue?vue&type=script&lang=js&"
export * from "./OldShop.vue?vue&type=script&lang=js&"
import style0 from "./OldShop.vue?vue&type=style&index=0&id=0437329c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0437329c",
  null
  
)

export default component.exports